module.exports = __webpack_public_path__ + "media/complexity-selector/essentials@1x-62ea57a2.png";